export default __webpack_public_path__ + "static/media/datamining.94e6dfae.gif";